const data = [
  {
    className : "icon-icn_note",
    header : "request an item" ,
    subHeading : "Include item name and/or picture"
  },
  {
      className : "icon-icn_dollar",
      header : "post a bounty" ,
      subHeading : "How much you’re willing to pay for the item + delivery cost"
  },
  {
    className : "icon-icn_package_location",
    header : "Delivery Location" ,
    subHeading : "Location and person picking up the package"
  },
  {
    className : "icon-icn_wallet",
    header : "Payment" ,
    subHeading : "Confirm payment and finish"
  },
]

export default data;



// WEBPACK FOOTER //
// app/request_an_item/request_an_item_intro/request_an_item_data.jsx